import { countries, DEFAULT_COUNTRY, getCountryByCode } from '../constants/countries';
import './CountrySelect.css';

const CountrySelect = ({ value = DEFAULT_COUNTRY, onChange, ariaLabel = 'Select country code', selectId }) => {
  const activeCountry = value || DEFAULT_COUNTRY;

  const handleChange = (event) => {
    const next = getCountryByCode(event.target.value);
    if (onChange) {
      onChange(next);
    }
  };

  return (
    <div className="country-select">
      <img src={activeCountry.flag} alt={`${activeCountry.name} flag`} loading="lazy" width="24" height="18" />
      <select
        id={selectId}
        aria-label={ariaLabel}
        value={activeCountry.code}
        onChange={handleChange}
      >
        {countries.map((country) => (
          <option key={country.code} value={country.code}>
            {country.name} ({country.dialCode})
          </option>
        ))}
      </select>
    </div>
  );
};

export default CountrySelect;
